import { Button, Table, Text } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import { iconProps } from 'components/icon-props';
import { i18nKeys, type TranslateFunction, tKeys, useTranslation } from 'locales';
import { CollaboratorNameCell } from 'modules/Settings/Collaborators/CollaboratorRow/CollaboratorNameCell';
import type { User } from 'shared/hooks/use-load-users';
import { useResendInvitation } from 'shared/hooks/use-resend-invitation';

type PendingCollaboratorProps = {
  user: User;
  onClickRow: () => void;
};

export const PendingCollaborator = ({ user, onClickRow }: PendingCollaboratorProps) => {
  const { t } = useTranslation();
  const { resendInvitation, isResendInvitationLoading } = useResendInvitation();

  const { id } = user;

  return (
    <Table.Tr onClick={onClickRow} style={{ cursor: 'pointer' }}>
      <Table.Td w={50}>
        <Text size="sm" c="dimmed">
          {id}
        </Text>
      </Table.Td>
      <Table.Td>
        <CollaboratorNameCell user={user} />
      </Table.Td>
      <Table.Td>
        <Button
          leftSection={<IconRefresh {...iconProps(16)} />}
          disabled={isResendInvitationLoading}
          onClick={e => {
            e.stopPropagation();
            resendInvitation(id);
          }}
          variant="light"
          size="compact-sm"
        >
          {t(i18nKeys.FORM.INVITE_STAFF.RESEND_INVITATION)}
        </Button>
      </Table.Td>
    </Table.Tr>
  );
};

export function getPendingTableHeaders(t: TranslateFunction) {
  return [
    { title: 'ID' },
    { title: t(tKeys.SETTINGS.STAFF.COLLABORATOR_NAME) },
    { title: t(tKeys.SETTINGS.STAFF.PENDING) },
  ];
}
